'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _Arc = require('./Arc');

var _Arc2 = _interopRequireDefault(_Arc);

var _Loader = require('./Loader.scss');

var _Loader2 = _interopRequireDefault(_Loader);

var _Text = require('../Text/Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arcsAngles = {
  small: {
    light: 216,
    dark: 144
  },
  medium: {
    light: 108,
    dark: 108
  },
  large: {
    light: 180,
    dark: 180
  }
};
var strokeWidth = 4;
var sizesInPx = {
  small: 30,
  medium: 54,
  large: 102
};

var Loader = function (_WixComponent) {
  _inherits(Loader, _WixComponent);

  function Loader() {
    _classCallCheck(this, Loader);

    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
  }

  _createClass(Loader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          color = _props.color,
          text = _props.text;

      var sizeInPx = sizesInPx[size];
      var lightArcAngle = arcsAngles[size].light;
      var darkArcAngle = arcsAngles[size].dark;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_Loader2.default.loaderContainer, _Loader2.default[size], _Loader2.default[color]) },
        _react2.default.createElement(
          'div',
          {
            className: _Loader2.default.arcsContainer,
            style: {
              width: sizeInPx + 'px',
              height: sizeInPx + 'px' }
          },
          _react2.default.createElement(_Arc2.default, {
            angle: lightArcAngle,
            className: _Loader2.default.lightArc,
            strokeWidth: strokeWidth,
            viewBoxSize: sizeInPx
          }),
          _react2.default.createElement(_Arc2.default, {
            angle: darkArcAngle,
            className: _Loader2.default.darkArc,
            strokeWidth: strokeWidth,
            viewBoxSize: sizeInPx
          })
        ),
        text && _react2.default.createElement(
          'div',
          { className: _Loader2.default.text },
          _react2.default.createElement(
            _Text2.default,
            { appearance: 'T5', dataHook: 'loader-text' },
            this.props.text
          )
        )
      );
    }
  }]);

  return Loader;
}(_WixComponent3.default);

Loader.displayName = 'Loader';
Loader.propTypes = {
  /** The size of the loader */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),

  /** The color of the loader */
  color: _propTypes2.default.oneOf(['blue', 'white']),

  /** Text to be shown below the loader */
  text: _propTypes2.default.string
};
Loader.defaultProps = {
  size: 'medium',
  color: 'blue'
};
exports.default = Loader;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Loader/Loader.js
// module id = 131
// module chunks = 0 1